import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Progress(theme: Theme) {
  const isLight = theme.palette.mode === 'light';

  return {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          overflow: 'hidden',
        },
        bar: {
          borderRadius: 4,
        },
        buffer: {
          backgroundColor: 'transparent',
        },
      },
      variants: [
        {
          props: { color: 'primary' as const },
          style: {
            backgroundColor: theme.palette.primary[isLight ? 'lighter' : 'darker'],
          },
        },
      ],
    },
  };
}
